/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function() {
  $('#load-all-images').on('click', function() {
    let totalHiddenCounter = $('.d-none').length;
    $('.d-none').each(function(e, i) {
      $(this).addClass(totalHiddenCounter === 1 ? 'expanded-full' : 'expanded');
      $(this).removeClass('d-none');
    });
    $(this).remove();
  });

  if(window.innerWidth < 768) {

    $('.dynamic-slick-grid-container')
      .slick({
        focusOnSelect: true,
        accessibility: true,
        ariaPolite: false,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        swipe: true,
        rows: 0,
        adaptiveHeight: true,
        speed: 300,
        cssEase: "ease",
        prevArrow:
          '<div class="product-single__photo__nav__item product-single__photo__nav__item--prev"><i class="icon icon--left-l"></i></div>',
        nextArrow:
          '<div class="product-single__photo__nav__item product-single__photo__nav__item--next"><i class="icon icon--right-l"></i></div>',
        appendDots: $('.dynamic-slick-grid-container').parent().find(".js-product-slider-nav-dots"),
        appendArrows: $('.dynamic-slick-grid-container').parent().find(".js-product-slider-nav"),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false
            },
          },
        ]
      });


  }

});

const MOBILE_BREAKPOINT = 768;
const MAX_VISIBLE_SWATCHES_MOBILE = 7;
const MAX_VISIBLE_SWATCHES_DESKTOP = 10;

function handleSwatches() {
  const collection = document.querySelector('.template-collection');
  if (!collection) return;

  const productCards = collection.querySelectorAll('.product-card');
  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

  const currentMaxSwatches = isMobile ? MAX_VISIBLE_SWATCHES_MOBILE : MAX_VISIBLE_SWATCHES_DESKTOP;

  productCards.forEach((card) => {
    const swatchWrapper = card.querySelector('.swatches .product-item__linked');
    if (!swatchWrapper) return;

    const swatches = Array.from(swatchWrapper.querySelectorAll('.product-item__linked-item'));

    const existingCountElements = swatchWrapper.querySelectorAll('.swatch-more-count');
    existingCountElements.forEach(el => el.remove());

    swatches.forEach(swatch => {
      swatch.classList.remove('swatch-hide');
    });

    if (swatches.length > currentMaxSwatches) {
      const extraCount = swatches.length - currentMaxSwatches;

      swatches.forEach((swatch, index) => {
        if (index >= currentMaxSwatches) {
          swatch.classList.add('swatch-hide');
        }
      });

      const countElement = document.createElement('a');
      countElement.href = swatchWrapper.dataset.url;
      countElement.classList.add('swatch-more-count');
      countElement.textContent = `+${extraCount}`;
      swatchWrapper.appendChild(countElement);
    }
  });
}

document.addEventListener('DOMContentLoaded', handleSwatches);
window.addEventListener('resize', handleSwatches);
